import { render, staticRenderFns } from "./modalDetallePago.vue?vue&type=template&id=0abab6d4&scoped=true&"
import script from "./modalDetallePago.vue?vue&type=script&lang=js&"
export * from "./modalDetallePago.vue?vue&type=script&lang=js&"
import style0 from "./modalDetallePago.vue?vue&type=style&index=0&id=0abab6d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abab6d4",
  null
  
)

export default component.exports